
<script>
import BarList from '../components/bar-list'
import MennfForm from './mennf-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            mennf: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        mennfList: function () {
            return this.$store.getters.getMennfList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codmennf = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codmennf = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codmennf":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadMennf', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        }

    },

    components: {
        BarList, MennfForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Mensagem" 
                plural-entity="Mensagens Padrão"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="mennfList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="mennf in mennfList" v-bind:key="mennf.codmennf">
                    <div class="mark-green"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-3" style="float: left">
                                <span class="lbl-list"> {{metadata.mennf.codmennf.label}} </span>
                                <span class="data-list">{{ mennf.codmennf }}</span>
                            </div>
                            <div class="col-md-8 col-6" style="float: left">
                                <span class="lbl-list"> {{metadata.mennf.descricao.label}} </span>
                                <span class="lbl-title-produto">{{ mennf.descricao }}</span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(mennf.codmennf)" 
                                    v-on:view="handleEdit(mennf.codmennf, true)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <mennf-form v-if="showForm" :index="this.codmennf" :crud="this.crud" v-on:closeform="closeForm"></mennf-form>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/mennf-list.vue